module.exports = __webpack_public_path__ + "img/no1.6b059c36.svg";